import { useAuthenticationContext } from '@festina-life/authentication'
import { assertNotEmpty } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import { isProtectedBranchCategory } from '../../../../uiModels/branches/types'
import { useConciseBranch } from '../../../../uiModels/branches/useConciseBranch'
import { useRequiredBranchOperationsContext } from '../../../../workspace/operationsContext'
import { ManageSection } from '../../../manageSection/ManageSection'
import { ChangeBranchTypesButton } from '../manageBranch/ChangeBranchTypesButton'
import { CopyBranchButton } from '../manageBranch/CopyBranchButton'
import { PublishConfigurationToServerButton } from './PublishConfigurationToServerButton'

export const AdvancedManageBranch = () => {
  const translate = useTranslate()
  const { branchKey } = useRequiredBranchOperationsContext()
  const { isInTestMode } = useAuthenticationContext()
  const conciseBranch = useConciseBranch({
    branchName: branchKey.name,
    server: branchKey.server,
    shouldFallbackToStandard: true,
  })

  assertNotEmpty(conciseBranch)

  const isNonProtectedBranch = !isProtectedBranchCategory(
    conciseBranch.branchCategory,
  )

  return (
    <div className="flex flex-col gap-y-4 p-1">
      {isInTestMode && (
        <ManageSection
          title={translate(
            'branchDetailsPanel.tabs.advanced.section.publish.title',
          )}
          options={[
            {
              label: translate(
                'branchDetailsPanel.tabs.advanced.publishToServer',
                {
                  server: branchKey.server,
                },
              ),
              description: translate(
                'branchDetailsPanel.tabs.advanced.section.publish.help.publishToServer',
              ),
              button: (
                <PublishConfigurationToServerButton branchKey={branchKey} />
              ),
            },
          ]}
        />
      )}
      <ManageSection
        title={translate(
          'branchDetailsPanel.tabs.advanced.section.other.title',
        )}
        options={[
          {
            label: translate('branchDetailsPanel.tabs.manage.copyBranch'),
            description: translate(
              'branchDetailsPanel.tabs.advanced.section.other.help.copy',
            ),
            button: <CopyBranchButton branchKey={branchKey} />,
          },
          ...(isNonProtectedBranch
            ? [
                {
                  label: translate(
                    'branchDetailsPanel.tabs.advanced.changeTypes',
                  ),
                  description: translate(
                    'branchDetailsPanel.tabs.advanced.section.other.help.changeTypes',
                  ),
                  button: <ChangeBranchTypesButton branchKey={branchKey} />,
                },
              ]
            : []),
        ]}
      />
    </div>
  )
}
